import { render, staticRenderFns } from "./CardknoxXKey.vue?vue&type=template&id=504e09bf&"
import script from "./CardknoxXKey.vue?vue&type=script&lang=ts&"
export * from "./CardknoxXKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports